module.exports = __webpack_public_path__ + "static/media/rightls.e8b9ba5c.png";